import { routes, userRoles } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import i18n from "../../../i18n/i18n";

export const useChatMenuUtils = (userSession) => {
  const tempMenuGroup = [];

  /* menuItemChat */
  const menuItemChat = {
    id: "chat",
    title: i18n.t("AppModuleNames.Provider.Chat"),
    url: baseRouteMaker(routes.USER_CHAT),
  };
  tempMenuGroup.push(menuItemChat);
  /* menuItemChat */

  /* menuItemStaffChat */
  // const menuItemStaffChat = {
  //   id: "staffChat",
  //   title: "Staff Chat",
  //   url: baseRouteMaker(routes.STAFF_CHAT),
  // };
  // tempMenuGroup.push(menuItemStaffChat);
  /* menuItemStaffChat */

  /* menuItemRequest */
  const menuItemRequest = {
    id: "request",
    title: i18n.t("Modules.Request.RequestList.title"),
    url: baseRouteMaker(routes.CHAT_REQUEST),
  };
  userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN &&
    tempMenuGroup.push(menuItemRequest);
  /* menuItemRequest */

  return tempMenuGroup;
};
